import { Box, BoxProps } from '@careguide/theme'
import Close from 'components/SVG/Close'
import styled from 'styled-components'

export type ModalContentProps = BoxProps &
  any & {
    $contentBackgroundColor?: string
  }

type BackgroundProps = {
  $backgroundOpacity: string
}

export const Content = styled(Box)<ModalContentProps>`
  background-color: ${(props) => props.$contentBackgroundColor || 'white'};
  border-radius: 5px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
  text-align: center;
`
export const CloseContainer = styled(Box)`
  text-align: right;
`

export const CloseButton = styled(Close)`
  cursor: pointer;
`

export const Background = styled.div<BackgroundProps>`
  background-color: rgba(59, 59, 62, ${(props) => props.$backgroundOpacity});
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition: all 0.3s ease-out;
`

export const contentDimension = { _: '300px', tablet: '600px' }
